import { Controller } from '@hotwired/stimulus';
import Swiper, { Navigation } from 'swiper/swiper-bundle.min.js';

export default class extends Controller {
  static targets = ['prev', 'next'];
  connect() {
    Swiper.use([Navigation]);
    new Swiper(this.element, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      watchOverflow: true,

      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1000: {
          slidesPerView: 'auto',
          spaceBetween: 48,
        },
      },

      navigation: {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
      },
    });
  }
}
